import { render, staticRenderFns } from "./warning-status.vue?vue&type=template&id=cb60ac1a&"
import script from "./warning-status.vue?vue&type=script&lang=js&"
export * from "./warning-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb60ac1a')) {
      api.createRecord('cb60ac1a', component.options)
    } else {
      api.reload('cb60ac1a', component.options)
    }
    module.hot.accept("./warning-status.vue?vue&type=template&id=cb60ac1a&", function () {
      api.rerender('cb60ac1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/warning-status.vue"
export default component.exports